var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-filter',{attrs:{"filters":_vm.filters,"setups-count":_vm.filteredSetups.length,"carrozzeria":_vm.carrozzeria},on:{"filter-changed":_vm.applyFilter}}),_vm._v(" "),_c('car-equipment',{attrs:{"quotation_id":_vm.quotation_id,"setups":_vm.filteredSetups}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2d34ab6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/app/components/CarFilterContainer.vue
// module id = hQhV
// module chunks = 1